import Vue from 'vue'
import Router from 'vue-router'

import ErrorPage from '@/components/ErrorPage'

import Login from '@/components/Login/Login'
import User from '@/components/User/User'
import Group from '@/components/Group/Group'
import Page from '@/components/Page/Page'
import Branch from '@/components/Branch/Branch'
import Company from '@/components/Company/Company'
import Position from '@/components/Position/Position'
import UserBranch from '@/components/UserBranch/UserBranch'
import UserGroup from '@/components/UserGroup/UserGroup'
import PageGroup from '@/components/PageGroup/PageGroup'
import Brand from '@/components/master/Brand'
import Part from  '@/components/master/Part'
import Customer from  '@/components/master/Customer'
import Insurance from  '@/components/master/Insurance'
import Model from  '@/components/master/Model'
import Color from  '@/components/master/Color'
import Car from  '@/components/master/Car'
import Service from  '@/components/master/Service'
import Supplier from  '@/components/master/Supplier'
import Consumable from  '@/components/master/Consumable'
import Employee from  '@/components/master/Employee'
import {isValidSession} from '@/assets/js/common.js'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)

const routes =  [
  {
    path: '/error',
    name: 'error',
    component: ErrorPage
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/user',
    name: 'user',
    component: User
  },
  {
    path: '/group',
    name: 'group',
    component: Group
  },
  {
    path: '/page',
    name: 'page',
    component: Page
  },
  {
    path: '/branch',
    name: 'branch',
    component: Branch
  },
  {
    path: '/company',
    name: 'company',
    component: Company
  },
  {
    path: '/user-branch',
    name: 'user-branch',
    component: UserBranch
  },
  {
    path: '/position',
    name: 'position',
    component: Position
  },
  {
    path: '/user-group',
    name: 'user-group',
    component: UserGroup
  },
  {
    path: '/page-group',
    name: 'page-group',
    component: PageGroup
  },
  {
    path: '/brand',
    name: 'brand',
    component: Brand
  },
  {
    path: '/part',
    name: 'part',
    component: Part
  },
  {
    path: '/customer',
    name: 'customer',
    component: Customer
  },
  {
    path: '/insurance',
    name: 'insurance',
    component: Insurance
  },
  {
    path: '/model',
    name: 'model',
    component: Model
  },
  {
    path: '/color',
    name: 'color',
    component: Color
  },
  {
    path: '/car',
    name: 'car',
    component: Car
  },
  {
    path: '/service',
    name: 'service',
    component: Service
  },
  {
    path: '/supplier',
    name: 'supplier',
    component: Supplier
  },
  {
    path: '/consumable',
    name: 'consumable',
    component: Consumable
  },
  {
    path: '/employee',
    name: 'employee',
    component: Employee
  }
]

let router = new Router({routes: routes});

router.beforeEach((to, from, next) => {
  if (to.name !== 'login') {
    isValidSession() ? next() : next('/login');
  } else {
    next();
  } 
})

export default router